// Identity attribute vocabulary shared by browser signals (Dash0 Web SDK),
// server spans, and structured logs — one key filters all signals in Dash0.
//
// `user.id` is the OTel-standard user-identity attribute (the Dash0 Sessions
// UI attributes sessions by it); it always carries the profile id. The
// `numa.*` keys are org-namespaced custom attributes: the OTel attribute
// registry has no equivalent for reservations, properties, or PMS guests.
// These are span/log/web-event attributes only — never metric or resource
// attributes (unbounded cardinality, per-request values).

export type IdentityIds = {
  /** Guest-account profile id (Cognito) — becomes `user.id`. */
  profileId?: string;
  /** PMS person id (profile.guestId or a check-in guest's personId). */
  guestId?: string;
  reservationId?: string;
  propertyId?: string;
};

export const IDENTITY_ATTRIBUTE_KEYS = {
  profileId: 'user.id',
  guestId: 'numa.guest.id',
  reservationId: 'numa.reservation.id',
  propertyId: 'numa.property.id',
} as const satisfies Record<keyof IdentityIds, string>;

export const toIdentityAttributes = (ids: IdentityIds): Record<string, string> =>
  Object.fromEntries(
    (Object.entries(ids) as [keyof IdentityIds, string | undefined][]).flatMap(([id, value]) =>
      value ? [[IDENTITY_ATTRIBUTE_KEYS[id], value]] : [],
    ),
  );
